module.exports = __webpack_public_path__ + "img/4.06e10e30.svg";